import { ComponentProps, ReactNode } from "react";
import { HeaderSection, UpdatedContainer } from "../../Common/__styles__/Modal";
import { Body, Title } from "../../Common/Typography";

export function LayoutContainer({
  content,
  title,
  subtitle,
  size = "small",
}: {
  content: ReactNode;
  title: string;
  subtitle?: Maybe<string>;
  size?: ComponentProps<typeof UpdatedContainer>["size"];
}) {
  return (
    <UpdatedContainer
      size={size}
      css={{
        "@media (max-height: 768px) and (min-width: 768px)": {
          maxHeight: "90vh",
        },
      }}
    >
      <HeaderSection>
        <Title size="small" type="semiBold">
          {title}
        </Title>
        {subtitle ? (
          <Body type="regular" size="large" color="contentSecondary">
            {subtitle}
          </Body>
        ) : null}
      </HeaderSection>
      {content}
    </UpdatedContainer>
  );
}
